import _ from 'lodash'
import { createPopper } from '@popperjs/core'
import Vue from 'vue'

export default Vue.directive('tooltip', {
  bind (el, binding) {
    // Get tooltip options.
    let placement = 'top'
    let text

    if (_.isPlainObject(binding.value)) {
      placement = _.get(binding.value, 'placement') || 'top'
      text = _.get(binding.value, 'text')
    } else {
      text = binding.value
    }

    // Create tooltip.
    const tooltip = document.createElement('div')

    tooltip.classList.add('popper-tooltip')
    tooltip.innerHTML = text

    el.appendChild(tooltip)

    // Add arrow to tooltip.
    const arrow = document.createElement('div')

    arrow.classList.add('arrow')
    arrow.dataset.popperArrow = ''

    tooltip.appendChild(arrow)

    // Create popper.
    let popperInstance = null

    function create () {
      popperInstance = createPopper(el, tooltip, {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8]
            }
          }
        ],
        placement
      })
    }

    function destroy () {
      if (popperInstance) {
        popperInstance.destroy()
        popperInstance = null
      }
    }

    function show () {
      tooltip.setAttribute('data-show', '')
      create()
    }

    function hide () {
      tooltip.removeAttribute('data-show')
      destroy()
    }

    const showEvents = ['mouseenter', 'focus']
    const hideEvents = ['mouseleave', 'blur']

    showEvents.forEach(event => {
      el.addEventListener(event, show)
    })

    hideEvents.forEach(event => {
      el.addEventListener(event, hide)
    })
  }
})
